<template>
  <div>
    <template v-for="section in sections">
      <div :key="`s-${section.key}`" class="sp-grp">
        <v-icon x-small>{{ section.icon }}</v-icon>
        {{ section.title }}
        <button v-if="section.key === 'searches'" class="sp-grp__more" type="button" @click="$emit('clear-searches')">leeren</button>
      </div>
      <a v-for="entry in section.entries" :key="entry.key" :aria-selected="String(entry.key === activeKey)"
         :class="{ 'sp-hit--active': entry.key === activeKey }" :data-key="entry.key" :href="hrefOf(entry)" class="sp-hit"
         role="option" @click.prevent="$emit('run', {entry, newTab: $event.metaKey || $event.ctrlKey})" @mouseenter="$emit('hover', entry)">
        <span class="sp-hit__ini">
          <v-icon v-if="entry.icon" small>{{ entry.icon }}</v-icon>
          <template v-else>{{ entry.initials }}</template>
        </span>
        <span class="sp-hit__main">
          <span class="sp-hit__title d-block">{{ entry.title }}</span>
          <span v-if="entry.subtitle" class="sp-hit__sub d-block">{{ entry.subtitle }}</span>
        </span>
        <span v-if="entry.pinned" class="sp-hit__end">
          <v-btn v-tip="'Nicht mehr anheften'" aria-label="Nicht mehr anheften" icon x-small @click.prevent.stop="$emit('unpin', entry)">
            <v-icon small>mdi-star-off-outline</v-icon>
          </v-btn>
        </span>
      </a>
    </template>
    <div class="sp-grp">
      <v-icon x-small>mdi-lightbulb-outline</v-icon>
      Tipps
    </div>
    <div v-for="tip in tips" :key="tip.title" class="sp-hit" style="cursor: default">
      <span class="sp-hit__ini"><v-icon small>{{ tip.icon }}</v-icon></span>
      <span class="sp-hit__main">
        <span class="sp-hit__title d-block">{{ tip.title }}</span>
        <span class="sp-hit__sub d-block" style="white-space: normal">{{ tip.text }}</span>
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import Vue, {PropType} from 'vue';
import {EmptyEntry, EmptySection} from '@/components/app/search/searchEmptyEntries';
import {shortcutLabel} from '@/helpers/shortcut.helper';

const tips = () => [
  {
    icon: 'mdi-pound',
    title: 'Nummern, Telefon, E-Mail, PLZ',
    text: 'Kundennummer, Telefonnummer, E-Mail-Adresse oder PLZ/Ort führen direkt zum Profil.',
  },
  {
    icon: 'mdi-filter-variant',
    title: 'Kürzel für Bereiche',
    text: '„s:“ Schüler:innen · „e:“ Eltern · „m:“ Mitarbeitende · „l:“ Lehrkräfte · „b:“ Bewerber:innen · „st:“ Standorte · „k:“ Kurse · '
        + '„sc:“ Schulungen · „p:“ Produkte',
  },
  {
    icon: 'mdi-keyboard-outline',
    title: 'Tastatur',
    text: `${shortcutLabel('K')} öffnet die Suche · ↑↓ auswählen · ↵ öffnen · ${shortcutLabel('Enter')} neuer Tab · ⇥ Filter wechseln · Esc schließen`,
  },
];

/** Content without search term: recent visits, pinned profiles, recent searches, quick actions and tips */
export default Vue.extend({
  props: {
    sections: {type: Array as PropType<EmptySection[]>, required: true},
    activeKey: {type: String, default: ''},
  },
  computed: {
    tips: () => tips(),
  },
  methods: {
    hrefOf(entry: EmptyEntry): string | undefined {
      return entry.to ? this.$router.resolve(entry.to).href : undefined;
    },
  },
});
</script>
